import { Component } from 'react';
import sharedStyles from '../single-page.module.scss';
import styles from './uuid-generator.component.module.scss';
import { genStyles } from '../converter-layout/generator-layout';

interface UuidState {
    uuids: string[];
    count: number;
    upperCase: boolean;
    copiedIdx: number | null;
    copiedAll: boolean;
}

export default class UuidGeneratorComponent extends Component<{ feature?: string }, UuidState> {
    private copyTimeout: ReturnType<typeof setTimeout> | null = null;

    state: UuidState = { uuids: [], count: 1, upperCase: false, copiedIdx: null, copiedAll: false };

    componentDidMount() { this.generate(); }

    generate = () => {
        const uuids = Array.from({ length: this.state.count }, () => crypto.randomUUID());
        this.setState({ uuids, copiedIdx: null, copiedAll: false });
    };

    format = (uuid: string) => this.state.upperCase ? uuid.toUpperCase() : uuid;

    copySingle = (idx: number) => {
        navigator.clipboard.writeText(this.format(this.state.uuids[idx])).then(() => {
            if (this.copyTimeout) clearTimeout(this.copyTimeout);
            this.setState({ copiedIdx: idx, copiedAll: false });
            this.copyTimeout = setTimeout(() => this.setState({ copiedIdx: null }), 2000);
        });
    };

    copyAll = () => {
        const text = this.state.uuids.map(u => this.format(u)).join('\n');
        navigator.clipboard.writeText(text).then(() => {
            if (this.copyTimeout) clearTimeout(this.copyTimeout);
            this.setState({ copiedAll: true, copiedIdx: null });
            this.copyTimeout = setTimeout(() => this.setState({ copiedAll: false }), 2000);
        });
    };

    render() {
        const { uuids, count, upperCase, copiedIdx, copiedAll } = this.state;

        return (
            <div className="row">
                <div className="col-12">
                    <div className={genStyles.section}>
                        <div className={styles.controls}>
                            <label className={sharedStyles.label} style={{ margin: 0 }}>Count:</label>
                            <input type="number" inputMode="decimal" className={styles.countInput} min={1} max={100} value={count}
                                onChange={e => this.setState({ count: Math.min(100, Math.max(1, +e.target.value || 1)) })}
                                aria-label="Number of UUIDs" />
                            <div className={styles.toggleGroup}>
                                <button className={`${styles.toggleBtn} ${!upperCase ? styles.toggleActive : ''}`}
                                    onClick={() => this.setState({ upperCase: false })}>lowercase</button>
                                <button className={`${styles.toggleBtn} ${upperCase ? styles.toggleActive : ''}`}
                                    onClick={() => this.setState({ upperCase: true })}>UPPERCASE</button>
                            </div>
                        </div>

                        <div className={styles.actions}>
                            <button className={sharedStyles.buttonPrimary} onClick={this.generate}>Generate</button>
                            {uuids.length > 1 && (
                                <button className={`${sharedStyles.copyButton} ${copiedAll ? sharedStyles.copyButtonSuccess : ''}`}
                                    onClick={this.copyAll}>{copiedAll ? '✓ Copied All' : 'Copy All'}</button>
                            )}
                        </div>
                    </div>

                    <div className={genStyles.section}>
                        <div className={styles.uuidList}>
                            {uuids.map((u, i) => (
                                <div key={i} className={styles.uuidRow}>
                                    <span>{this.format(u)}</span>
                                    <button className={`${sharedStyles.copyButton} ${copiedIdx === i ? sharedStyles.copyButtonSuccess : ''}`}
                                        onClick={() => this.copySingle(i)}>
                                        {copiedIdx === i ? '✓' : 'Copy'}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
